module.exports = __webpack_public_path__ + "static/img/American_Credit_Platform_for_Success_Most_Profitable.2de23f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/American_Credit_Platform_for_Success_Most_Profitable.png
// module id = 748
// module chunks = 5